import Dialog from './Dialog'
import Pagination from './Pagination'
import RemoveButton from './RemoveButton'
import CustomForm from './CustomForm'

const components = [Dialog, Pagination, RemoveButton, CustomForm]

export default {
  install(Vue) {
    components.forEach(Component => {
      Vue.use(Component)
    })
  }
}
